/**
 * Custom JS - Optimización de Rendimiento y Carga Diferida
 * lacarniceriavirtual.com
 */

document.addEventListener('DOMContentLoaded', function () {

  // =========================================================================
  // 1. CARGA DIFERIDA DE HERRAMIENTAS DE SEGUIMIENTO (GTM, PIXEL, CONTENTSQUARE)
  // =========================================================================
  initDeferredTracking();

  function initDeferredTracking() {
    var trackingLoaded = false;

    function loadTrackingScripts() {
      if (trackingLoaded) return;
      trackingLoaded = true;

      // --- A. GOOGLE TAG MANAGER (Centraliza GA4, Google Ads, Merchant) ---
      (function(w,d,s,l,i){
        w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window, document, 'script', 'dataLayer', 'G-1SBHQC9G82'); // <-- Sustituye con tu ID de GTM


      // --- B. META PIXEL (FACEBOOK) ---
      (function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      fbq('init', 'TU_PIXEL_ID'); // <-- Sustituye con tu ID de Pixel de Facebook
      fbq('track', 'PageView');


      // --- C. CONTENTSQUARE ---
      (function() {
        var cs = document.createElement('script');
        cs.type = 'text/javascript';
        cs.async = true;
        cs.src = '//t.contentsquare.net/uxa/3d139005edf64.js'; 
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(cs, s);
      })();

      // Limpiar listeners tras la ejecución
      events.forEach(function (e) {
        window.removeEventListener(e, loadTrackingScripts, { passive: true });
      });
    }

    // Escuchar la primera interacción real del usuario
    var events = ['keydown', 'mousemove', 'touchstart', 'scroll', 'click'];
    
    events.forEach(function (e) {
      window.addEventListener(e, loadTrackingScripts, { passive: true, once: true });
    });

    // Fallback: Si no hay interacción, cargar tras 4 segundos para asegurar métricas
    setTimeout(loadTrackingScripts, 4000);
  }


  // =========================================================================
  // 2. CARGA INTELIGENTE DE REBUY (INTERSECTION OBSERVER)
  // =========================================================================
  initLazyRebuy();

  function initLazyRebuy() {
    // Selector del contenedor donde Rebuy renderiza las recomendaciones
    var rebuyContainer = document.querySelector('.rebuy-widget, #rebuy-recommended-section, [data-rebuy-id]');
    
    // Configuración para tiendas Shopify
    var shopDomain = Shopify && Shopify.shop ? Shopify.shop : 'lacarniceriavirtual.myshopify.com';

    if (!rebuyContainer) {
      // Si el widget está en la parte superior visible (above the fold), cargarlo de inmediato
      loadRebuyScript(shopDomain);
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, observerInstance) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadRebuyScript(shopDomain);
            observerInstance.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '300px 0px' // Carga Rebuy 300px antes de que el usuario haga scroll hasta él
      });

      observer.observe(rebuyContainer);
    } else {
      loadRebuyScript(shopDomain);
    }

    function loadRebuyScript(shop) {
      if (window.Rebuy || document.getElementById('rebuy-js')) return;

      var script = document.createElement('script');
      script.id = 'rebuy-js';
      script.async = true;
      script.src = 'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=' + shop;
      document.head.appendChild(script);
    }
  }

});